import { makeStyles } from "@material-ui/core/styles";

const useCouponEditDialogStyles = makeStyles(
  {
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "20px"
    },
    cancelButton: {
      backgroundColor: "#F4F4F4",
      marginRight: "10px",
      padding: "6px 16px",
      width: 136
    },
    closeIcon: {
      margin: 10,
      padding: 5,
      position: "absolute",
      right: 0,
      top: 0
    },
    confirmButton: {
      "&:hover": {
        backgroundColor: "#ACCAFF"
      },
      "&:hover .MuiButton-label": {
        color: "#0030FF"
      },
      backgroundColor: "#0030FF",
      borderRadius: 6,
      color: "#FFFFFF",
      height: 39,
      padding: "6px 30px",
      width: 136
    },
    dialog: {
      borderRadius: 10,
      position: "relative",
      right: 0,
      top: 0,
      width: "35em"
    },
    dialogContent: {
      color: "#747C8C",
      fontSize: "14px",
      marginBottom: "30px",
      textAlign: "center"
    },
    textConfirm: {
      color: "#FFFFFF"
    },
    title: {
      border: "none",
      fontWeight: "bold"
    },
    titleText: {
      color: "#000000",
      fontSize: "1em",
      fontWeight: 800,
      marginTop: "1em",
      textAlign: "center"
    }
  },
  { name: "CouponEditDialog" }
);

export default useCouponEditDialogStyles;
